var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "word_box" }, [
    _c("p", { staticClass: "word_title" }, [_vm._v("公司委托授权书")]),
    _vm._m(0),
    _c("p", { staticClass: "indent" }, [
      _vm._v(
        "\n    本机构已充分理解并同意《大陆云盾数字证书服务协议》的全部条款，现授权下述被授权人前往贵机构办理数字证书相关业务，并愿承担相应的法律后果。具体授权内容如下：\n  "
      )
    ]),
    _c(
      "div",
      { staticClass: "indent" },
      [
        _vm._m(1),
        _c("p", [
          _c("span", { staticClass: "line-title" }, [_vm._v("机构名称：")]),
          _c("span", { staticClass: "underline" }, [
            _vm._v(_vm._s(_vm.license.enterpriseName))
          ])
        ]),
        _c("p", [
          _c("span", { staticClass: "line-title" }, [
            _vm._v("统一社会信用代码：")
          ]),
          _c("span", { staticClass: "underline" }, [
            _vm._v(_vm._s(_vm.license.businessLicenseNo))
          ])
        ]),
        _c("p", [
          _c("span", { staticClass: "line-title" }, [
            _vm._v("法定代表人/负责人姓名：")
          ]),
          _c("span", { staticClass: "underline" }, [
            _vm._v(_vm._s(_vm.license.enterpriseController))
          ])
        ]),
        _vm._m(2),
        _c(
          "el-form",
          {
            ref: "formRef",
            staticClass: "list_ul list_right",
            attrs: { model: _vm.grantAuth, rules: _vm.formRules }
          },
          [
            _c("p", [
              _c("span", { staticClass: "line-title" }, [_vm._v("姓名：")]),
              _c(
                "span",
                { staticClass: "underline", staticStyle: { width: "60%" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "list_li",
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { prop: "enterpriseController11" }
                    },
                    [
                      _c("el-input", {
                        ref: "nameFocusRef",
                        attrs: {
                          autofocus: true,
                          size: "mini",
                          placeholder: "请输入被授权人名称"
                        },
                        model: {
                          value: _vm.grantAuth.enterpriseController11,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.grantAuth,
                              "enterpriseController11",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "grantAuth.enterpriseController11"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("p", [
              _c("span", { staticClass: "line-title" }, [
                _vm._v("身份证号码：")
              ]),
              _c(
                "span",
                { staticClass: "underline", staticStyle: { width: "60%" } },
                [
                  _vm.isInLand
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "list_li",
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { prop: "IDCard11" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入被授权人身份证号"
                            },
                            model: {
                              value: _vm.grantAuth.IDCard11,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.grantAuth,
                                  "IDCard11",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "grantAuth.IDCard11"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        {
                          staticClass: "list_li",
                          staticStyle: { "margin-bottom": "0" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入被授权人证件号码"
                            },
                            model: {
                              value: _vm.grantAuth.IDCard11,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.grantAuth,
                                  "IDCard11",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "grantAuth.IDCard11"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ]),
            _c("p", [
              _c(
                "span",
                { staticClass: "line-title", staticStyle: { width: "60%" } },
                [
                  _vm._v(
                    "手机号码（账号绑定、接收短信通知和校验信息指定渠道）："
                  )
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "underline",
                  staticStyle: { "margin-left": "31%", width: "60%" }
                },
                [
                  _vm.isInLand
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "list_li",
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { prop: "bankLinkPhone11" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              maxlength: 11,
                              minlength: 11,
                              placeholder: "请输入被授权人联系电话"
                            },
                            model: {
                              value: _vm.grantAuth.bankLinkPhone11,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.grantAuth,
                                  "bankLinkPhone11",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "grantAuth.bankLinkPhone11"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        {
                          staticClass: "list_li",
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { prop: "bankLinkEmail" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入被授权人联系邮箱"
                            },
                            model: {
                              value: _vm.grantAuth.bankLinkEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.grantAuth,
                                  "bankLinkEmail",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "grantAuth.bankLinkEmail"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ])
          ]
        ),
        _vm._m(3),
        _c("p", [_vm._v("1．进行机构实名认证；")]),
        _c("p", [
          _vm._v(
            "2．进行机构数字证书申请、下载、更新、撤销及签名私钥托管等操作；"
          )
        ]),
        _c("p", [
          _vm._v(
            "3．使用数字认证进行电子签名、电子签章、身份认证及数据加解密等操作。"
          )
        ]),
        _vm._m(4),
        _c("p", [
          _vm._v(
            "自本授权书加盖本机构公章之日起至数字证书有效期截止之日止。以上授权转让无效。"
          )
        ]),
        _vm._m(5),
        _c("p", [
          _vm._v(
            "1.本机构充分知悉上述委托授权的法律意义及由此产生的法律结果，确认作出上述授权并承担法律责任。\n      同时，保证提交的机构信息和资料真实、准确、完整和有效，其扫描件与原件具有同等法律效力。\n    "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n      2.本机构如因业务需要将数字证书对应的签名私钥委托第三方平台保管，且采用免意愿认证的方式进行私钥签名操作，\n      相关使用风险及后果均由本机构承担。\n    "
          )
        ]),
        _vm._m(6),
        _c("p", [
          _vm._v(
            "\n      1.数字证书对应的签名私钥是实现可靠电子签名的核心制作数据与身份凭证，\n      直接关系到签名的真实性、完整性与不可否认性。贵机构应自行生成并妥善保管签名私钥。\n    "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n      2.如因业务需要将签名私钥委托第三方平台保管（即“私钥托管”），\n      请务必在私钥托管前充分评估安全风险，并与该第三方签订书面服务协议，明确约定私钥调用权限、签署流程及责任划分等事项。\n    "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n      3.大陆云盾依法签发及管理数字证书，对贵机构选择委托第三方托管私钥的行为不承担审查或担保义务。\n      因第三方原因导致私钥被未经授权使用、篡改或泄露的，相关法律后果及经济损失由贵机构与该第三方自行协商处理，\n      大陆云盾不承担任何连带责任。\n    "
          )
        ])
      ],
      1
    ),
    _vm._m(7)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("致： 大陆云盾电子认证服务有限公司 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("一、本机构信息")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("二、被授权人信息")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("三、授权内容")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("四、授权期限")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("本机构郑重承诺：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("数字证书使用风险提示：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "word-end" }, [
      _c("div", { staticClass: "sufix" }, [
        _c("p", [
          _c("span", { staticClass: "su-title" }, [_vm._v("授权机构盖章：")])
        ]),
        _c("p", [
          _c("span", { staticClass: "su-title" }, [_vm._v("被授权人签字：")])
        ]),
        _c("p", [
          _c("span", { staticClass: "su-title" }, [_vm._v("日       期：")]),
          _c("span", { staticClass: "enpty-bottom" }),
          _vm._v("年"),
          _c("span", { staticClass: "enpty-bottom" }),
          _vm._v("月"),
          _c("span", { staticClass: "enpty-bottom" }),
          _vm._v("日")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b811179", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b811179","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/wordCustom.vue
// module id = Pwl6
// module chunks = 38 39 58 105 251